import { useEffect } from 'react'
import { useAppSelector } from '@/redux/hooks'
import { usePostHog } from 'posthog-js/react'
import { isReverStaff } from '@/domain/dashboard-user'
import { useLocation } from 'react-router'

export function usePageVisit() {
  const location = useLocation()
  const posthog = usePostHog()
  const me = useAppSelector((store) => store.userApi.getMe.response.user)

  useEffect(() => {
    // Until getMe answers staff can't be told apart, so no pageview is sent yet.
    if (!me?.name || !me?.group) return
    if (isReverStaff({ email: me.name, group: me.group })) return
    posthog.capture('$pageview')
  }, [location.pathname, posthog, me?.name, me?.group])
}
